import { CreditCard, Smartphone, Users } from 'lucide-react'
import { FC } from 'react'
import ShowcaseCard from '../../components/Showcase/ShowcaseCard'
import ShowcaseHeader from '../../components/Showcase/ShowcaseHeader'

const FeatureShowcase: FC = () => (
	<div className="max-w-md w-full">
		<h2 className="text-4xl font-bold mb-8 text-left">Hit Em Up Admin Dashboard</h2>
		<div className="space-y-8 mb-12">
			<ShowcaseCard>
				<ShowcaseHeader icon={<Users size={24} className="text-hitemup-green" />} title="Family Management" />
				<p className="text-lg opacity-90">
					Easily manage family members and set custom permissions for each user.
				</p>
			</ShowcaseCard>
			<ShowcaseCard>
				<ShowcaseHeader
					icon={<CreditCard size={24} className="text-hitemup-green" />}
					title="Billing & Subscriptions"
				/>
				<p className="text-lg opacity-90">
					Handle payments, view invoices, and manage your subscription plans effortlessly.
				</p>
			</ShowcaseCard>
			<ShowcaseCard>
				<ShowcaseHeader
					icon={<Smartphone size={24} className="text-hitemup-green" />}
					title="Mobile App Integration"
				/>
				<p className="text-lg opacity-90">
					Upload contacts via CSV in the dashboard, then use our mobile app for sending messages and real-time
					communication.
				</p>
			</ShowcaseCard>
		</div>
		<div className="text-center">
			<p className="text-lg font-semibold mb-4">Get started with your admin dashboard today!</p>
		</div>
	</div>
)

export default FeatureShowcase
